import { apiGet, apiPut } from "./client";
import { getApiToken } from "../data/api/token";
export type FeatureValue = string | number | boolean;
export interface FeatureDefinition {
  id: string;
  name: string;
  type: "boolean" | "number" | "string" | "select";
  unit: string;
  options: { id: string; label: string }[];
  archived: boolean;
}
export interface VehicleRequirement {
  attributeId: string;
  operator: "eq" | "gte" | "lte";
  value: FeatureValue;
}
export interface FeatureSchema {
  revision: number;
  enabled: boolean;
  definitions: FeatureDefinition[];
}
export interface FeatureResource {
  revision: number;
  values?: Record<string, FeatureValue>;
  requirements?: VehicleRequirement[];
  schema: FeatureSchema;
  editable: boolean;
}
export interface FeatureMatch {
  vehicleId: string;
  name: string;
  registrationNumber: string;
  status: "compatible" | "incompatible" | "unknown";
  drivers: { driverId: string; name: string }[];
  checks: {
    name: string;
    operator: string;
    value: FeatureValue;
    actual: FeatureValue | null;
    actualLabel?: string | null;
    expectedLabel?: string | null;
    unit: string;
    status: string;
  }[];
}
export async function featureGet<T>(
  workspace: string,
  path: string,
): Promise<T> {
  return (
    await apiGet(
      await getApiToken(),
      `/api/vehicle-features/${path}`,
      workspace,
    )
  ).data;
}
export async function featurePut<T>(
  workspace: string,
  path: string,
  body: unknown,
): Promise<T> {
  return (
    await apiPut(
      await getApiToken(),
      `/api/vehicle-features/${path}`,
      body,
      workspace,
    )
  ).data;
}
